import React, { useEffect, useState } from 'react';
import { Container, Card, Chip, TextareaAutosize, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, TextField, Stack, Avatar, FormControlLabel, Checkbox , Tooltip} from '@mui/material';

import { getAvailableProducts } from '../services/products.js';
import { getAvailableItems } from '../services/item.js';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import utc from 'dayjs/plugin/utc';
import { FormControl, InputLabel, Select, OutlinedInput, Box, MenuItem, FormHelperText } from '@mui/material'
import FrequentProducts from './frequentProducts.jsx'

import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { addBook, getProductFrequency } from '../services/booking.js';
import PostCheckout from './postCheckout.js';
import { getActiveUsers } from '../services/user.js';
import { downloadBook } from '../util/index.js';

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUserAction } from '../actions/profile.js';


dayjs.extend(isSameOrBefore);
dayjs.extend(utc);

const styles = {
  root: {
    margin: 0,
    padding:2,
  },
  closeButton: {
    position: 'absolute',
    right: 1,
    top: 1,
    color: 'palette.grey[500]',
  },
};

const styleObj = {
  body:{
    width:'100%',
    display:'flex',
    height: {xs:'60vh', sm:'60vh', md:'100%', lg:'100%'}
  },
  dateCont: {
      display: 'flex',
      marginBottom: 10
  },
  dateInd: {
      marginRight: 20
  },
  tenantCont: {
      marginBottom : 20
  },
  itemCont: {
    marginBottom : 20
  },
  left: {
      width: '55%'
  },
  right: {
    width: '50%',
    position: 'relative',
    height: 'calc(100% - 55px)',
    paddingBottom: '55px',
  },
  selItemCont: {
    display: 'flex',
    marginBottom:5,
    position: 'relative',
    minHeight:'80px'
  },
  selItemImg: {
    width: 100,
    objectFit:'contain'
  },
  selItemImgCont: {
    marginRight: 10,
    marginBottom: 5,
    display:'flex'
  },
  selItemDetCont: {
    marginTop:5
  },
  selItemActionCont: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 0
  },
  totalCont: {
    position:'absolute',
    bottom:0,
    width: '100%'
  },
  selTotCont: {
    display: 'flex',
    height: 60,
    alignItems:'center'
  },
  totalEl: {
    width: 100,
    marginRight: 10,
    color: 'black',
    height: '15px'
  },
  dialoge: {
    height:'100%',
    maxHeight: '500px'
}, 
};

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

const DialogTitleComponent =(props) => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle style={{display: 'flex', position: 'relative'}} sx={styles.root} {...other}>
      <Typography component="div" >{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close"  style={{right: '25px', position: 'absolute'}} sx={styles.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const DialogContentComponent =  ({
                                fromDate, setFromDate, toDate, setToDate, billableDates, setBillableDates, itemCountMatch, setItemCountMatch,setBookingAdded,setBookingError,
                                tenants, selectedTenant, setSelectedTenant, items, selectedItems, setSelectedItems,  displayItem, amount, saveLoad, setSaveLoad,handleCloseButton,
                                setDisplayItem, isMobile, note, setNote, advance, setAdvance, discount, setDiscount, setAmount, openPostCheckout, setOpenPostCheckout, frequentProducts
                            }) => {
    if (openPostCheckout) {
        return (
            <PostCheckout
                fromDate={fromDate}
                toDate={toDate}
                tenant={selectedTenant}
                amount={amount}
                discount={discount}
                billableDates={billableDates}
                open={openPostCheckout}
                advance={advance}
                products={selectedItems}
                setAdvance={setAdvance}
                bookingNote={note}
                setOpenPostCheckout={setOpenPostCheckout}
                saveLoad={saveLoad}
                setSaveLoad={setSaveLoad}
                setBookingAdded={setBookingAdded}
                setBookingError={setBookingError}
                handleCloseButton={handleCloseButton}
            />
        )
    }
  return (
    <DialogContent sx={{height:{xs:'90vh', sm:'90vh'}}} dividers style={{height: '100%'}}>
            <Container sx={styleObj.body} style={isMobile ? {flexDirection:'column'} : {}}>
                <div style={isMobile ? {...styleObj.left, width:'100%' } : styleObj.left}>
                    <DateBar fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate}/>
                    {/*<Typography variant="caption" display="block" gutterBottom component="div">{` ${numberofDays} ${diffTitle}`} </Typography>*/}
                    <BillableDates fromDate={fromDate} toDate={toDate} billableDates={billableDates} setBillableDates={setBillableDates}/>
                    <Tenant tenants={tenants} selectedTenant={selectedTenant} setSelectedTenant={setSelectedTenant}/>
                    <FrequentProducts products={frequentProducts} onSelect={()=>{}} items={items} selectedItems={selectedItems} setSelectedItems={setSelectedItems} fromDate={fromDate} toDate={toDate}/>
                    <ItemSelect fromDate={fromDate} toDate={toDate} items={items} selectedItems={selectedItems} setSelectedItems={setSelectedItems} displayItem={displayItem} setDisplayItem={setDisplayItem}/>
                    {!isMobile && (<TextField
                        aria-label="Notes"
                        placeholder="Notes"
                        multiline
                        minRows={5}
                        value={note}
                        onChange={(e)=>{setNote(e.target.value)}}
                        style={{ width: '90%' }}
                    />)}
                </div>
                <div style={isMobile ? { ...styleObj.right, width:'100%'} : styleObj.right}>
                  <div style={{maxHeight:'300px', overflowY:'scroll'}}>
                    {selectedItems.map(sel=><SelectedItemsCard itemCountMatch={itemCountMatch} setItemCountMatch={setItemCountMatch} isMobile={isMobile} selectedItems={selectedItems} setSelectedItems={setSelectedItems} key={sel._id} product={sel}/>)}
                  </div>
                    <div style={styleObj.totalCont}>
                      <TotalCard isMobile={isMobile} advance={advance} setAdvance={setAdvance} discount={discount} setDiscount={setDiscount} setAmount={setAmount} numberofDays={billableDates.length} selectedItems={selectedItems}/>
                    </div>
                </div>
            </Container>
        </DialogContent>
  )

};

const DialogActionsComponent = ({handleAddBookingClose, saveLoad, billableDates, selectedItems, selectedTenant, handleClick, isPostCheckout, openPostCheckout, itemCountMatch}) => {
    if (openPostCheckout) {
        return null
    }
    else {
        return (
            <DialogActions>
                <Button onClick={handleAddBookingClose} color="secondary">
                    Cancel
                </Button>
                <Button disabled={!itemCountMatch || saveLoad || billableDates.length  === 0 || selectedItems.length === 0 || !selectedTenant } autoFocus onClick={handleClick()} color="primary">
                    {isPostCheckout ? "Next" : "Save"} {saveLoad && <CircularProgress size={20} sx={{ color: 'blue', marginLeft:'20px' }}/>}
                </Button>
            </DialogActions>
        )
    }

}


const DateBar = ({fromDate, setFromDate, toDate, setToDate}) => {

  const [fromDateOpen, setFromDateOpen] = useState(false);
  const [toDateOpen, setToDateOpen] = useState(false);

  const now = dayjs();
  const yesterday = now.subtract(1, 'd');

  // Helper to calculate min time
  const getMinTime = (date) => {
    if (!date) return null;

    // If the selected date is today
    /*if (date.isSame(now, 'day')) {
      return now.hour() < 8 ? now.set('hour', 7).set('minute', 0) : now.startOf('hour');
    }*/
    
    // For future dates, set minimum time to 8 AM
    return dayjs().set('hour', 7).set('minute', 0);
  };

  const minTime = getMinTime(fromDate);
  const minEndTime = getMinTime(toDate);
  const maxTime = dayjs().set('hour', 22).set('minute', 0); // 10 PM
    return (
        <div style={styleObj.dateCont}>
            <div style={styleObj.dateInd} >
              <LocalizationProvider dateAdapter={AdapterDayjs}>                      
                  <DesktopDateTimePicker
                      label="From Date"
                      open={fromDateOpen}
                      skipDisabled={true}
                      onOpen={() => setFromDateOpen(true)}
                      onClose={() => {
                        setFromDateOpen(false)
                        setToDateOpen(true); // Open second picker when first closes
                      }}
                      value={fromDate}
                      minDate={yesterday.startOf('day')}
                      maxDate={now.add(30, 'day').endOf('day')}
                      minTime={minTime}
                      maxTime={maxTime}
                      ampm={true}
                      timeSteps={{ hours: 1, minutes: 60 }}
                      format='DD/MM/YYYY HH:mm'
                      onChange={(newValue) => {
                          setFromDate(newValue);
                      }}
                      slots={{ textField: TextField }}
                      slotProps={{
                        textField: {
                          inputProps: { readOnly: true },
                          onClick: (e) => {setFromDateOpen(true); e.stopPropagation()} // optional: avoid triggering focus behavior
                        }
                      }}
                    />
                </LocalizationProvider>
            </div>
            <div style={styleObj.dateInd}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDateTimePicker
                      label="To Date"
                      open={toDateOpen}
                      onOpen={() => setToDateOpen(true)}
                      onClose={() => {
                        setToDateOpen(false); // Open second picker when first closes
                      }}
                      value={toDate}
                      skipDisabled={true}
                      ampm={true}
                      maxDate={now.add(30, 'day').endOf('day')}
                      minTime={minEndTime}
                      maxTime={maxTime}
                      minDate={dayjs(fromDate)}
                      format='DD/MM/YYYY HH:mm'
                      timeSteps={{ hours: 1, minutes: 60 }}
                      onChange={(newValue) => {
                          setToDate(newValue);
                      }}
                    />
                  </LocalizationProvider>
            </div>
      </div>
    )
}

const Tenant = ({tenants, setSelectedTenant, selectedTenant}) => {    
    return (
        <div style={styleObj.tenantCont}>
            <Autocomplete
            disablePortal
            getOptionLabel={(option) => { if (typeof option === "string"){ return option } return option?.user?.name}} // Used for display
            id="combo-box-tenant"
            options={tenants}
            value={selectedTenant}
            filterOptions={(opts, { inputValue }) =>
              opts.filter((opt) => {
                const search = inputValue.toLowerCase();
                return (
                  opt.user.name.toLowerCase().includes(search) ||
                  opt.user.contactNumber.includes(search)
                );
              })
            }
            onChange={(e, v, r)=>{setSelectedTenant(v)}}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                <Avatar alt={option.user.name} src={option?.user?.image?.thumb}/>
                <Typography>{option.user.name}</Typography>
                </Stack>
              </li>
            )}
            sx={{ width: { xs: 250, sm: 300, md:300, lg: 300, xl: 300 } }}
            ListboxProps={{
              style: {
              maxHeight:'200px',
              zIndex:5
              }
            }}
            renderInput={(params) => <TextField {...params} label="Tenant" />}
            />
        </div>
      );
}

const ItemSelect = ({fromDate, toDate, items, displayItem, setDisplayItem, setSelectedItems, selectedItems}) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleSelect = async (event, value, reason) => {
        if (value) {
            value.count = 1;
            const index = selectedItems.findIndex(selItem =>selItem._id === value._id)
            if (index < 0) {
              try {
                value.availableItems = await getAvailableItems(dayjs(fromDate).format('YYYY-MM-DD HH:mm'), dayjs(toDate).format('YYYY-MM-DD HH:mm'), value._id)
                value.availableItems = value.availableItems.map(_ => ({..._, rent: value.rent}))                
                value.items = [value.availableItems[0]]
                const _selectedItems = [...selectedItems, value]
                setSelectedItems(_selectedItems)
              } catch (e) {
                if (e.status === 401) {
                    dispatch(removeUserAction())
                    navigate('/');
                }
              }
            }
            setDisplayItem({name: ''})
        }
    }
    
    return (
        <div style={styleObj.itemCont}>
            <Autocomplete
            disablePortal
            ListboxProps={{
              style: {
              maxHeight:'200px',
              zIndex:5
              }
            }}
            getOptionLabel={option => option.name}
            id="combo-box-item"
            clearIcon={null}
            value={displayItem}
            onInputChange={(event, value, reason)=>{setDisplayItem({name: value})}}
            onChange={handleSelect}
            options={items}
            sx={{ width: { xs: 250, sm: 300, md:300, lg: 300, xl: 300 } }}
            renderInput={(params) => <TextField {...params} label="Item" />}
            />
        </div>
      );
}


const SKUSelect = ({SKUs, selectedSKUs, onSkuSelect, count, itemCountMatch, setItemCountMatch}) => {
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(undefined)
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        disablePortal: true,
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            }
        },
    };
    
    return (
        <FormControl sx={{ m: 1, width: 300 }} size="small">
            <InputLabel id="sku-select">SKU</InputLabel>
            <Select
                labelId="sku-select"
                id="sku-select"
                multiple
                disabled={SKUs.length === count && count === selectedSKUs.length}
                value={selectedSKUs}
                error={!itemCountMatch}
                onClose={()=>{
                    console.log(selectedSKUs.length, count)
                    if(selectedSKUs.length < count || selectedSKUs.length > count) {
                        setItemCountMatch(false)                        
                    } else {
                        setItemCountMatch(true)
                    }
                }}
                 onBlur={()=>{
                    console.log(selectedSKUs.length, count)
                    if(selectedSKUs.length < count || selectedSKUs.length > count) {
                        setItemCountMatch(false)                        
                    } else {
                        setItemCountMatch(true)
                    }
                }}
                onChange={onSkuSelect}
                input={<OutlinedInput id="sku-chip" label="SKU" />}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                            <Chip key={value.sku} label={value.sku} onClick={(e)=>{e.stopPropagation();}}/>
                        ))}
                    </Box>
                )}
                MenuProps={MenuProps}
            >
                {SKUs.map((item) => (
                    <MenuItem
                        key={item.sku}
                        value={item}
                    >
                        {item.sku}
                    </MenuItem>
                ))}
            </Select>
            {!itemCountMatch && <FormHelperText sx={{color: 'error.main'}}>Please add at least {count} item(s)</FormHelperText>}
        </FormControl>
    )
}

const SelectedItemsCard = ({product, isMobile, selectedItems, setSelectedItems, itemCountMatch, setItemCountMatch}) => {
  const handleRemove = (id) => {
      return (e) => {
        const index = selectedItems.findIndex(selItem =>selItem._id === id)
        if (index > -1) {
          const _selectedItems = [...selectedItems];
          _selectedItems.splice(index,1);
          setSelectedItems(_selectedItems)
        }
      }
    }
    const increment = (id) => {
      return (e) => {
        const index = selectedItems.findIndex(selItem =>selItem._id === id)
        if (index > -1 && selectedItems[index].count < selectedItems[index].availableItemsCount) {
          const _selectedItems = [...selectedItems];
          _selectedItems[index].count += 1
          setSelectedItems(_selectedItems)
          if (_selectedItems[index].items.length !== selectedItems[index].count) {
            setItemCountMatch(false)
          } else {
            setItemCountMatch(true)
          }
        }
      }
    }
    const decrement = (id) => {
      return (e) => {
        const index = selectedItems.findIndex(selItem =>selItem._id === id)
        if (index > -1 && selectedItems[index].count > 1) {
          const _selectedItems = [...selectedItems];
          _selectedItems[index].count -= 1
          setSelectedItems(_selectedItems)
          if (_selectedItems[index].items.length !== selectedItems[index].count) {
            setItemCountMatch(false)
          } else {
            setItemCountMatch(true)
          }
        }
      }
    }
    const onSkuSelect = (id) => {
      return (e) => {
        const index = selectedItems.findIndex(selItem =>selItem._id === id)
        if (index > -1 && e.target.value.length <= selectedItems[index].count) {
          const _selectedItems = [...selectedItems];
          _selectedItems[index].items = e.target.value
          setSelectedItems(_selectedItems)
        }
      }
    }

  return(
    <Card sx={styleObj.selItemCont}>
      <div  style={styleObj.selItemImgCont}><img style={styleObj.selItemImg} src={product.image.thumb}/></div>
      <div style={styleObj.selItemDetCont}>
        <Typography variant="subtitle2" gutterBottom component="div">{product.name}</Typography>
        <Typography variant="caption" display="block" gutterBottom component="div">₹ {product.rent} /-</Typography>
        <SKUSelect
            SKUs={product.availableItems}
            selectedSKUs={product.items || []}
            onSkuSelect={onSkuSelect(product._id)}
            count={product.count}
            itemCountMatch={itemCountMatch}
            setItemCountMatch={setItemCountMatch}
        />
      </div>
      <div style={isMobile ? {bottom:'0px', ...styleObj.selItemActionCont} : styleObj.selItemActionCont}>
        <div><IconButton disabled={product.count === 1} onClick={decrement(product._id)}><RemoveIcon/></IconButton></div>
        <div>{product.count}</div>
        <div><IconButton disabled={product.count === product.availableItemsCount} onClick={increment(product._id)}><AddIcon/></IconButton></div>
        <div><IconButton  onClick={handleRemove(product._id)}><DeleteIcon/></IconButton></div>
      </div>
    </Card>
  )
}

const TotalCard = ({selectedItems=[], isMobile, advance, setAdvance, numberofDays, setAmount, discount, setDiscount}) => {
  const [total, setTotal] = useState(0);
  useEffect(()=>{
    setAmount(total-discount);
  },[discount, total])
  useEffect(()=>{
    const _total = selectedItems.reduce((acc, item)=>{return acc+(parseInt(item.rent, 10)*numberofDays*item.count)}, 0)
    setTotal(_total)
  },[selectedItems, numberofDays])
  if (Array.isArray(selectedItems) && selectedItems.length > 0) {
    return (
      <Card sx={styleObj.selTotCont}>
        <div><TextField sx={styleObj.totalEl} variant="standard" style={isMobile ? {...styleObj.totalEl, width:'75px'} : styleObj.totalEl} disabled={true} label="Gross Total" value={`₹ ${total}/-`} /></div>
        <div> <TextField sx={styleObj.totalEl} variant="standard" style={isMobile ? { ...styleObj.totalEl, width:'75px'} : styleObj.totalEl} value={discount} onChange={(e)=>{setDiscount(e.target.value)}} defaultValue={0} label="Discount (₹)" /></div>
        <div> <TextField sx={styleObj.totalEl} variant="standard" style={isMobile ? {...styleObj.totalEl, width:'75px'} : styleObj.totalEl} value={advance} onChange={(e)=>{setAdvance(e.target.value)}} defaultValue={0} label="Advance (₹)" /></div>
        <div><TextField sx={styleObj.totalEl} variant="standard" style={isMobile ? { ...styleObj.totalEl, width:'75px'} : styleObj.totalEl} disabled={true} label="Net Total" value={`₹ ${total - discount}/-`} /></div>
      </Card>
    )
  }
  return null;
}

const BillableDates = ({fromDate, toDate, setBillableDates, billableDates}) => {
  let dayNameArray = []
  const handleCheckBoxClick = (date) => {
    return (e) => {
      if (e.target.checked) {
        setBillableDates([...billableDates, date])
      } else {
        const _billableDates = [...billableDates]
        const index = _billableDates.indexOf(date)
        if (index > -1) {
          _billableDates.splice(index, 1)
          setBillableDates(_billableDates)
        }
      }
    }
  }
  for (let currentDate = dayjs(fromDate); currentDate.isSameOrBefore(toDate, "day"); currentDate = currentDate.add(1, 'day')) {
    dayNameArray.push(
      <Tooltip key={currentDate.format('ddd')}  title={currentDate.format("DD MMM")}>
        <FormControlLabel control={<Checkbox onChange={handleCheckBoxClick(currentDate.format("DD-MM-YYYY"))} checked={billableDates.indexOf(currentDate.format("DD-MM-YYYY")) > -1}/>} label={currentDate.format('ddd')} />
      </Tooltip>)
  }
  return (
    <Stack direction="column" alignItems="flex-start">
    <Stack direction="row" alignItems="center">
      <Typography sx={{mr: 1}}>Select Billable Date : </Typography>
      {dayNameArray}      
    </Stack>
    <Typography sx={{ml: 1}} variant="caption" display="block" gutterBottom component="div">{billableDates.length} days </Typography>
    </Stack>
  )
}

export default function CustomizedDialogs(props) {
    const defaultStartDate = dayjs().add(1, 'hour').minute(0).second(0) 
    const defaultEndDate = defaultStartDate.add(1, 'day')

    const [saveLoad, setSaveLoad] = useState(false);
    const [fromDate, setFromDate] = useState(defaultStartDate)
    const [toDate, setToDate] = useState(defaultEndDate)
    const [billableDates, setBillableDates] = useState([])
    const [tenants, setTenants] = useState([])
    const [selectedTenant, setSelectedTenant] = useState();
    const [selectedItems, setSelectedItems] = useState([]);
    const [displayItem, setDisplayItem] = useState({name:''});
    const [items, setItems] = useState([])
    const [numberofDays, setNumberofDays] = useState(1)
    const [note, setNote] = useState('');
    const [amount, setAmount] = useState(0)
    const [discount, setDiscount] = useState(0);
    const [advance, setAdvance] = useState(0);
    const [isPostCheckout, setIsPostCheckout] = useState(false)
    const [openPostCheckout, setOpenPostCheckout] = useState(false)
    const [itemCountMatch, setItemCountMatch] = useState(true)
    const [frequentProducts, setFrequentProducts] = useState([])
    
    const isMobile = getWindowDimensions().width < 500 ? true : false;
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    React.useEffect(()=>{
      if (props.editableProduct) {
          const getProductData  = async(id) => {
        }
        getProductData(props.editableProduct)          
      }
    }, [props.editableProduct])

    useEffect(()=>{
        const fetchTenants = async() => {
          try {
            const _tenants = await getActiveUsers();
            setTenants(_tenants.filter(x=>x.status=== "APPROVED"))
          } catch (e) {
            if (e.status === 401) {
                dispatch(removeUserAction())
                navigate('/');
            }
          }
        }
        fetchTenants()
    }, [])

    useEffect(()=>{
        const getData = async() => {
          if (dayjs(toDate).isAfter(dayjs(fromDate))) {
            setNumberofDays(dayjs(toDate).diff(dayjs(fromDate), 'days')+1)
            try {
              const data = await getAvailableProducts(dayjs(fromDate).utc().toISOString(), dayjs(toDate).utc().toISOString());
              setSelectedItems([])
              setItems(data)
            } catch (e) {
              if (e.status === 401) {
                dispatch(removeUserAction())
                navigate('/');
              }
            }
          }
        }

        /*let dayNameArray = []
        for (let currentDate = dayjs(fromDate); currentDate.isSameOrBefore(toDate, "day"); currentDate = currentDate.add(1, 'day')) {
          dayNameArray.push(currentDate.format("DD-MM-YYYY"))
        }*/
        const currentDate = dayjs(fromDate);
        if (currentDate.isSame(toDate, "day")) {
          setBillableDates([currentDate.format("DD-MM-YYYY")])
        }
        if (currentDate.isBefore(dayjs(), "hour")) {
          setIsPostCheckout(true)
        } else {
          setIsPostCheckout(false)
        }
        
        getData()
    }, [fromDate, toDate])

    const getFrequncy = async (tenantId) => {
      if (tenantId) {
        const prediction = await getProductFrequency(tenantId)
        console.log(prediction)
        setFrequentProducts(prediction.items)
      }
    }

    useEffect(()=>{
      if (selectedTenant) {
        getFrequncy(selectedTenant.user._id)
      }
    }, [selectedTenant])
    
    
    const resetFields = () => {
      setFromDate(defaultStartDate)
      setToDate(defaultEndDate)
      setSelectedTenant('')
      setAdvance(0);
      setDiscount(0);
      setBillableDates([])
    }

    const handleAddBookingClose = (e) => {
      if (!saveLoad) {
        if (openPostCheckout) {
          setOpenPostCheckout(false)
        }
        else {
          props.setShowAddBooking(false);
          resetFields()
        }
      }   
    }

    const handleCloseButton = (e) => {
      if (!saveLoad) {    
         if (openPostCheckout) {
          setOpenPostCheckout(false)
        }   
        console.log("Close button click")
          props.setShowAddBooking(false);
          resetFields()
      }   
    }

    const handleClick =()=> { 
      return async (e) => {        
        if (isPostCheckout) {
          setOpenPostCheckout(true)
        } else {
          const data = {
            //from: fromDate.format('YYYY-MM-DD HH:mm'),
            //to: toDate.format('YYYY-MM-DD HH:mm'),
            from: fromDate.utc().toISOString(),
            to: toDate.utc().toISOString(),
            tenant: selectedTenant.userId,
            products: selectedItems.map(item=>{return{id: item._id, count: item.count, items: item.items}}),
            note: note,
            amount: amount,
            discount: discount,
            advance: advance,
            billableDates: billableDates,
          }          
          try {
            setSaveLoad(true)
            const resp = await addBook(data)
            downloadBook(resp)
            props.setBookingAdded()
            setSaveLoad(false)
            handleCloseButton();
          } catch (e) {
            if (e.status === 401) {
                dispatch(removeUserAction())
                navigate('/');
            }
            console.log(e)
            setSaveLoad(false)
            props.setBookingError('Could not book')
          }
        }
      }
    }

    const diffTitle = numberofDays > 1 ? 'days' : 'day';
  return (
      <Dialog sx={{height:{xs:'90vh', sm:'90vh'}}} onClose={handleCloseButton} fullWidth={true}
        maxWidth={"md"} aria-labelledby="customized-dialog-title" open={props.open}>
        <DialogTitleComponent id="customized-dialog-title" onClose={handleCloseButton}>
          <Stack direction="row">
            Add New Booking
            {isPostCheckout && <Chip sx={{ml: 2}}label="POST CHECKOUT" variant="outlined"/>}
          </Stack>
        </DialogTitleComponent>
        <DialogContentComponent
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          billableDates={billableDates}
          setBillableDates={setBillableDates}
          tenants={tenants}
          selectedTenant={selectedTenant}
          setSelectedTenant={setSelectedTenant}
          items={items}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          displayItem={displayItem}
          setDisplayItem={setDisplayItem}
          isMobile={isMobile}
          note={note} 
          setNote={setNote}
          advance={advance}
          setAdvance={setAdvance}
          discount={discount}
          setDiscount={setDiscount}
          setAmount={setAmount}
          amount={amount}
          openPostCheckout={openPostCheckout}
          setOpenPostCheckout={setOpenPostCheckout}
          itemCountMatch={itemCountMatch}
          setItemCountMatch={setItemCountMatch}
          saveLoad={saveLoad}
          setSaveLoad={setSaveLoad}
          setBookingAdded={props.setBookingAdded}
          setBookingError={props.setBookingError}
          handleCloseButton={handleCloseButton}
          frequentProducts={frequentProducts}
        />
        <DialogActionsComponent
          handleAddBookingClose={handleAddBookingClose}
          saveLoad={saveLoad}
          billableDates={billableDates}
          selectedItems={selectedItems}
          selectedTenant={selectedTenant}
          handleClick={handleClick}
          isPostCheckout={isPostCheckout}
          openPostCheckout={openPostCheckout}
          itemCountMatch={itemCountMatch}
        />
      </Dialog>
  );
}
